<!-- Transaction History Table -->
<div class="card shadow-sm">
  <div
    class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
  >
    <h5 class="mb-0">Enterprise Requests</h5>
  </div>
  <!-- Tabs -->
  <!-- Status Tabs -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="selectedTab === 1"
        (click)="changeTab(1)"
        style="cursor: pointer"
      >
        Pending
      </a>
    </li>
     <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="selectedTab === 2"
        (click)="changeTab(2)"
        style="cursor: pointer"
      >
        In-Process
      </a>
    </li>
     <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="selectedTab === 3"
        (click)="changeTab(3)"
        style="cursor: pointer"
      >
        Documents Uploaded
      </a>
    </li>

    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="selectedTab === 4"
        (click)="changeTab(4)"
        style="cursor: pointer"
      >
        Approved
      </a>
    </li>

    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="selectedTab === 5"
        (click)="changeTab(5)"
        style="cursor: pointer"
      >
        Rejected
      </a>
    </li>
  </ul>
  <div class="card-body p-0">
    <div class="table-responsive">
      <table
        class="table  table-hover mb-0"
        id="transactionTable"
      >
        <thead class="">
          <tr>
            <th>Name</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          <tr class="fw-bold" *ngFor="let data of enterpriseRequests">
            <td>{{ data.enterpriseName }}</td>
            <td>{{ data.phone }}</td>
            <td>{{ data.email }}</td>

           

            <!-- ⭐ ACTION DROPDOWN -->
            <td class="text-center">
              <div ngbDropdown class="d-inline-block">
                <button
                  class="btn btn-sm btn-primary dropdown-toggle"
                  ngbDropdownToggle
                >
                  Action
                </button>

                <div ngbDropdownMenu>
                  <button class="dropdown-item" (click)="viewRequest(data._id)">
                    👁️ View
                  </button>
              

                  <!-- <button
                    class="dropdown-item"
                    (click)="approveRequest(data._id)"
                  >
                    ✔️ Approve
                  </button>

                  <button
                    class="dropdown-item"
                    (click)="rejectRequest(data._id)"
                  >
                    ❌ Reject
                  </button> -->
                </div>
              </div>
            </td>
          </tr>
          <div
            *ngIf="enterpriseRequests?.length == 0"
            class="text-center mt-2 mb-2"
          >
            <span class="text-danger">Data Not found</span>
          </div>
        </tbody>
      </table>
    </div>

    <ngb-pagination
      (pageChange)="gty((page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>
</div>
